import React from 'react';
import {Control, UseFormRegister} from 'react-hook-form';

import DelaySelector from 'shared/ui/DelaySelector/DelaySelector';
import InputHidden from 'shared/ui/Input/InputHidden';

import {INotifyChannelSettings} from '../../model/INotifyChannel';

interface INotifyDelaySelectorProps {
    settingsField: string,
    values: INotifyChannelSettings[],
    index: number,
    control: Control<any>,
    register: UseFormRegister<any>,
    itemId?: number,
}

const NotifyDelaySelector: React.FC<INotifyDelaySelectorProps> = ({
    settingsField,
    values,
    index,
    control,
    register,
    itemId,
}) => {
    const delay = values.find(s => Number(s?.id) === Number(itemId))?.delay ?? 0;

    return (
        <>
            <DelaySelector
                control={control}
                name={`${settingsField}.${index}.delay`}
                value={delay}
            />

            <InputHidden {...register(`${settingsField}.${index}.id`)} value={itemId} />
        </>
    );
};

export default NotifyDelaySelector;
